export default () => ({
  default: {
    BusinessName: '',
    Email: '',
    DispatchGroupEmail: '',
    FirstName: '',
    IsUK: 0,
    LastName: '',
    Location: {
      Id: 0,
      Name: ''
    },
    LocationId: 0,
    PartnerId: null,
    Role: '',
    Roles: [
      {
        Id: 0,
        Name: ''
      }
    ],
    TimeZone: '',
    UserId: 0,
    Username: '',
    IsActive: true,
    IsLockedOut: false,
    Password: ''
  },
  user: null,
  users: [],
  totalUsers: 0,
  currentUser: null,
  searchTerm: '',
  pageSize: 10,
  sortDir: 'asc',
  orderBy: 'Name',
  status: '',
  filterBy: 0,
  highlight: false,
  highlightPassword: false,
  source: null
})



// WEBPACK FOOTER //
// ./src/store/modules/users/state.js